import types from "./types";


export const getCartItems = () => ({
    type: types.GET_CART_ITEMS
})

// export const getDeliveryAddress = (cartId) => ({
//     type: types.GET_DELIVERY_ADDRESS,
//     cartId
// })


export const getRelatives = () => ({
    type: types.GET_RELATIVE
})

export const clearCart = () => ({
    type: types.CLEAR_CART
})


